import React, { useEffect, useState } from 'react'
import { GetCurrentRole_User_Api, SendVerifySms_User_Api, VerifyMobile_User_Api } from '../../API/userApi';
import { Button, Col, Input, Row, Card } from 'antd';
import { RegisterComponent } from './RegisterComponent';
import { GetLoginPageTitle_Setting_Api } from '../../API/SettingApi';
import { useNavigate } from "react-router-dom";

// =================================================================
export const LoginComponent = ({ setLoading, showMessage }) => {
    // =================================================================
    const [step, setStep] = useState("getMobile");
    const [mobile, setMobile] = useState("");
    const [verifyCode, setVerifyCode] = useState("");
    const [loginPageTitle, setLoginPageTitle] = useState();
    const navigate = useNavigate();

    // =================================================================
    useEffect(() => {
        loadSetting();
    }, []);
    
    const loadSetting = async () => {
        setLoading(true);
        try {
            const data = await GetLoginPageTitle_Setting_Api();
            setLoading(false);

            if (data.messageStatus == "Successful") {
                setLoginPageTitle(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }

    const sendVerifySms = async () => {
        setLoading(true);
        try {
            let data = await SendVerifySms_User_Api(mobile);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setStep("getVerifyCode");
                showMessage(data.message, "Successful")
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور", "error")
        }
    }

    const VerifyMobile = async () => {
        setLoading(true);
        try {
            var params = {
                mobile: mobile,
                code: verifyCode,
            }
            let data = await VerifyMobile_User_Api(params);
            setLoading(false);

            if (data.messageStatus == "Successful") {
                if (data.additional) {
                    setStep("loginUser");
                    localStorage.setItem('token', data.additional);
                    let rolData = await GetCurrentRole_User_Api();
                    localStorage.setItem('role', rolData.messageData.data);
                    navigate("/admin");
                }
                else
                    setStep("registerNewUser");
                showMessage(data.message, "Successful")
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور", "error")
        }
    }

    // اگر در حالت ثبت نام هستیم، کامپوننت ثبت نام را فول‌اسکرین نمایش می‌دهیم
    if (step === "registerNewUser") {
        return (
            <div style={{ 
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                padding: '20px',
                overflow: 'auto',
                zIndex: 1000
            }}>
                <Card 
                    style={{ 
                        maxWidth: '800px', 
                        margin: '20px auto',
                        borderRadius: '15px',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.1)'
                    }}
                >
                    
                    <RegisterComponent setLoading={setLoading} showMessage={showMessage} mobile={mobile} />
                </Card>
            </div>
        );
    }

    // حالت‌های عادی (ورود و دریافت کد)
    return (
        <>
            {step == "getMobile" ? (
                <Row justify="space-between">
                    <Col span={24}>
                        <h1>
                            {loginPageTitle ? loginPageTitle : <></>}
                        </h1>
                        <h3>
                            ورود / ثبت نام
                        </h3>
                    </Col>
                    <Col span={24}>
                        <input placeholder='شماره موبایل'
                         value={mobile} 
                         onChange={(e) => setMobile(e.target.value)} 
                         onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                sendVerifySms();
                            }
                        }}/>
                    </Col>
                    <Col span={24}>
                        <Button type="primary" onClick={() => sendVerifySms()}>تایید</Button>
                    </Col>
                </Row>
            ) : null}

            {
                step == "getVerifyCode" ? (
                    <Row justify="space-between" style={{ textAlign: 'center' }}>
                        <Col span={24}>
                            <h1>
                                کد تایید را وارد کنید
                            </h1>
                            <h4>
                                کد تایید را به شماره {mobile} فرستادیم
                            </h4>
                            <h4>
                                شماره موبایل اشتباه است؟ <span style={{ cursor: 'pointer' }} onClick={() => setStep('getMobile')}>ویرایش</span>
                            </h4>
                        </Col>
                        <Col span={24}>
                            <Input.OTP 
                            length={4}
                             style={{ direction: 'ltr', textAlign: 'center', width: '100%' }}
                              onChange={(text) => setVerifyCode(text)} 
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    VerifyMobile();
                                }
                            }}
                              />
                        </Col>
                        <Col span={24}>
                            <Button type="primary" onClick={() => VerifyMobile()}>ورود</Button>
                        </Col>
                        <Col span={24}>
                            <h4>
                                پیامک دریافت نکردید؟ <span style={{ cursor: 'pointer' }} onClick={() => setStep('getMobile')}>ارسال مجدد</span>
                            </h4>
                        </Col>
                    </Row>
                ) : null
            }
        </>
    )
}


/*import React, { useEffect, useState } from 'react'
import { GetCurrentRole_User_Api, SendVerifySms_User_Api, VerifyMobile_User_Api } from '../../API/userApi';
import { Button, Col, Input, Row } from 'antd';
import { RegisterComponent } from './RegisterComponent';
import { GetLoginPageTitle_Setting_Api } from '../../API/SettingApi';
import { useNavigate } from "react-router-dom";

// =================================================================
export const LoginComponent = ({ setLoading, showMessage }) => {
    // =================================================================
    const [step, setStep] = useState("getMobile");
    const [mobile, setMobile] = useState("");
    const [verifyCode, setVerifyCode] = useState("");
    const [loginPageTitle, setLoginPageTitle] = useState();
    const navigate = useNavigate();

    // =================================================================
    useEffect(() => {
        loadSetting();
    }, []);
    // =================================================================
    const loadSetting = async () => {
        setLoading(true);
        try {
            const data = await GetLoginPageTitle_Setting_Api();
            setLoading(false);

            if (data.messageStatus == "Successful") {
                setLoginPageTitle(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const sendVerifySms = async () => {
        setLoading(true);
        try {
            let data = await SendVerifySms_User_Api(mobile);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setStep("getVerifyCode");
                showMessage(data.message, "Successful")
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور", "error")
        }
    }
    // =================================================================
    const VerifyMobile = async () => {
        setLoading(true);
        try {
            var params = {
                mobile: mobile,
                code: verifyCode,
            }
            let data = await VerifyMobile_User_Api(params);
            setLoading(false);

            if (data.messageStatus == "Successful") {
                //اگر کاربر از قبل وجود دارد که لاگین در غیر اینصورت ثبت نام
                if (data.additional) {
                    setStep("loginUser");
                    localStorage.setItem('token', data.additional);
                    let rolData = await GetCurrentRole_User_Api();
                    localStorage.setItem('role', rolData.messageData.data);

                    navigate("/admin");

                }
                else
                    setStep("registerNewUser");
                showMessage(data.message, "Successful")
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور", "error")
        }
    }
    // =================================================================
    return (
        <>
            {step == "getMobile" ? (
                <Row justify="space-between">
                    <Col span={24}>
                        <h1>
                            {loginPageTitle ? loginPageTitle : <></>}
                        </h1>
                        <h3>
                            ورود / ثبت نام
                        </h3>
                    </Col>
                    <Col span={24}>
                        <input placeholder='شماره موبایل'
                         value={mobile} 
                         onChange={(e) => setMobile(e.target.value)} 
                         onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                sendVerifySms();
                            }
                        }}/>
                    </Col>
                    <Col span={24}>
                        <Button type="primary" onClick={() => sendVerifySms()}>تایید</Button>
                    </Col>
                </Row>
            ) : (<></>)
            }

            {
                step == "getVerifyCode" ? (
                    <Row justify="space-between" style={{ textAlign: 'center' }}>
                        <Col span={24}>
                            <h1>
                                کد تایید را وارد کنید
                            </h1>
                            <h4>
                                کد تایید را به شماره {mobile} فرستادیم
                            </h4>
                            <h4>
                                شماره موبایل اشتباه است؟ <span style={{ cursor: 'pointer' }} onClick={() => setStep('getMobile')}>ویرایش</span>
                            </h4>
                        </Col>
                        <Col span={24}>
                            <Input.OTP 
                            length={4}
                             style={{ direction: 'ltr', textAlign: 'center', width: '100%' }}
                              onChange={(text) => setVerifyCode(text)} 
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    VerifyMobile();
                                }
                            }}
                              />
                        </Col>
                        <Col span={24}>
                            <Button type="primary" onClick={() => VerifyMobile()}>ورود</Button>
                        </Col>
                        <Col span={24}>
                            <h4>
                                پیامک دریافت نکردید؟ <span style={{ cursor: 'pointer' }} onClick={() => setStep('getMobile')}>ارسال مجدد</span>
                            </h4>
                        </Col>
                    </Row>
                ) : (<></>)
            }

            {
                step == "registerNewUser" ? (
                    <RegisterComponent setLoading={setLoading} showMessage={showMessage} mobile={mobile} />
                ) : (<></>)
            }
        </>
    )
}
*/